/**
 * PUBBLICAZIONI DELLA SCUOLA DI GENOVA — elenco ufficiale del Centro («Pubblicazioni Scuola di Genova», aggiornato ad agosto 2026).
 * Struttura: autore → sezione (volumi, volumi in collaborazione, curati…) → voci bibliografiche verbatim.
 */
export interface PubblicazioneSezione { titolo: string; voci: string[] }
export interface AutorePubblicazioni { autore: string; sezioni: PubblicazioneSezione[] }
export const pubblicazioni: AutorePubblicazioni[] = [
  { autore: "Mario Gennari", sezioni: [
    { titolo: "Volumi:", voci: [
      "Pedagogia e semiotica, La Scuola, Brescia, 1984 (I ed.), pp.275 – 1998 (II ed.), pp.316",
      "Lo sguardo iconico. Per un’educazione all’immagine, La Scuola, Brescia, 1984 (I ed.), pp.146 – 1986 (II ed.), pp.148",
      "Pedagogia degli ambienti educativi, Armando, Roma, 1988 (I ed.) – 1997 (II ed.), pp.174",
      "Interpretare l’educazione. Pedagogia, semiotica, ermeneutica, La Scuola, Brescia, 1992, pp.222 – 2003 (II ed.), pp.232",
      "L’educazione estetica, Bompiani, Milano, 1994 (I ed.) – 1995 (II ed.) – 2007 (VI ed.), pp.367",
      "Storia della Bildung. Formazione dell’uomo e storia della cultura in Germania e nella Mitteleuropa, La Scuola, Brescia, 1995 (I ed.) – 1997 (II ed.), pp.444",
      "Semantica della città e educazione, Marsilio, Venezia, 1995, pp.353",
      "Filosofia della formazione dell’uomo, Bompiani, Milano, 2001, – 2005 (II ed.), pp. 804",
      "Trattato di Pedagogia Generale, Bompiani, Milano, 2006, – 2007 (II ed.), – 2009 (III ed.), – 2015 (IV ed.) pp.484",
      "Filosofia del pensiero, Il Melangolo, Genova, 2007, – 2007 (II ed.) – 2008 (III ed.), pp.68",
      "L’Eidos del mondo, Bompiani, Milano, 2012, pp.876 – 2013 (II ed.)",
      "Formema, Il Melangolo, Genova, 2015, pp.94",
      "Missa in tempore belli, Il Melangolo, Genova, 2015, pp.96",
      "Herrad von Landsberg e l’Hortus deliciarum, Il Melangolo, Genova, 2017, pp.152",
      "Dalla paideia classica alla Bildung divina, Bompiani, Milano, 2017, – 2018 (II ed.), pp.752",
      "Filosofia del discorso, Il Melangolo, Genova, 2018, pp.136",
      "Trattatello di prosòdica. Che cosa è, com’è e chi è la nostra voce?, Il Melangolo, Genova, 2019, pp.71",
      "La Bildung neoumanistica. Germania e Europa nell’Età di Goethe, Istituto italiano per gli studi filosofici, La Scuola di Pitagora, Napoli, 2023, pp.378",
      "Photo-Graphie. 1826-2026. La fotografia come metafora della realtà, Fabrizio Serra Editore, Pisa-Roma, pp.176",
      "Trattato di Pedagogia Generale, Il Melangolo, Genova, in corso di pubblicazione",
    ] },
    { titolo: "Volumi in collaborazione:", voci: [
      "Strategie per l’insegnamento (in collab. con R. Cerri), Franco Angeli, Milano, 1987, pp.181",
      "Prolegomeni alla Pedagogia Generale (in collab. con A. Kaiser), Bompiani, Milano, 2000, pp.124 -2004 (II ed.), pp.142 – 2005 (III ed.)",
      "Logica, linguaggio e metodo in pedagogia (in collab. con G. Sola), Il Melangolo, Genova, 2016, pp.197",
      "Leopardi come educatore (in collab. con F. Cambi), Il Melangolo, Genova, 2018, pp.9",
      "Allegorie dell’Infanzia (in collab. Con F. Marcone), Il Melangolo, Genova, 2024, pp. 240",
    ] },
    { titolo: "Volumi curati:", voci: [
      "Alfabeti dell’immagine, Franco Angeli, Milano, 1985, pp.128",
      "Didattica dell’educazione visiva, La Scuola, Brescia, 1985, pp.159",
      "Estetiche dell’ambiente. Linguaggi per l’educazione, Sagep, Genova, 1988, pp.119",
      "Beni culturali e scuola, La Scuola, Brescia, 1988, pp.150",
      "La città educante, Sagep, Genova, 1989, pp.158",
      "L’insegnamento di don Lorenzo Milani, di E. Balducci, Laterza, Roma-Bari, 1995 (I ed.) – 1996 (II ed.) ‒ 2002 (III ed.), pp.141",
      "Didattica generale, Bompiani, Milano, 1996 (I ed.) - 1999 (II ed.), pp.429; 2002 (III ed.), pp.526",
      "L’apocalisse di don Milani, Scheiwiller, Milano, 2008, pp.245",
      "La veglia di un solitario, di J.H. Pestalozzi, Il Melangolo, Genova, 2009, pp.58",
      "Il bambino e la sua arte. Novantanove tesi, di C. Ghezzi, Il Melangolo, Genova, 2010, pp.106",
      "Educare è educarsi, di H.-G. Gadamer, Il Melangolo, Genova, 2014, pp.77",
      "Deutsche Bildung, di E. Troeltsch, Il Melangolo, Genova, 2015, pp.136",
      "Hortulus. Coltura e cultura del giardino, di Walahfrid von Reichenau, Il Melangolo, Genova, 2017, pp.152",
      "Neuhumanismus. Pedagogie e culture del Neoumanesimo tedesco tra Settecento e Ottocento. Primo Volume, Il Melangolo, Genova, 2018, pp.366",
      "Neuhumanismus. Pedagogie e culture del Neoumanesimo tedesco tra Settecento e Ottocento. Secondo Volume, Il Melangolo, Genova, 2019, pp. 487",
      "Neuhumanismus. Pedagogie e culture del Neoumanesimo tedesco tra Settecento e Ottocento. Terzo Volume, Il Melangolo, Genova, 2020, pp. 568",
      "La Pedagogia dell’Encyclopédie. Testi di D’Alembert, Diderot, Du Marsais, Jaucourt, Mallet, Naigeon, Villeneuve, Yvon, Fabrizio Serra, Pisa-Roma, 2025, pp. 200",
    ] },
    { titolo: "Volumi tradotti e pubblicati all’estero", voci: [
      "La educación estética. Arte y literatura, Paidós, Barcelona – Buenos Aires – México, 1997, pp.333",
      "Semántica de la ciudad y educación. Pedagogía de la ciudad, Herder, Barcelona, 1998, pp.174",
    ] },
  ] },
  { autore: "Giancarla Sola", sezioni: [
    { titolo: "Volumi", voci: [
      "Umbildung. La “trasformazione” nella formazione dell’uomo, Bompiani, Milano, 2003, pp. 176",
      "La genesi teoretica della paideia classica, Aracne, Roma, 2005, pp. 103",
      "Heidegger e la pedagogia, Il Melangolo, Genova, 2008, pp. 199",
      "Archeologie della formazione occidentale, Anicia, Roma, 2008, pp. 236",
      "Introduzione alla Pedagogia Clinica, Il Melangolo, Genova, 2008, pp. 119",
      "La genesi filologica degli umanesimi classici, Aracne, Roma, 2009, pp. 153",
      "L’epistemologia pedagogica italiana e il “Documento Granese-Bertin”, Il Melangolo, Genova, 2015, pp. 285",
      "La formazione originaria. Paideia, humanitas, perfectio, dignitas hominis, Bildung, Bompiani, Milano, 2016, pp. 251",
      "Trattato di Pedagogia Clinica, Il Melangolo, Genova, pp. 280",
    ] },
    { titolo: "Volumi in collaborazione", voci: [
      "Mario Gennari, Giancarla Sola, Logica, linguaggio e metodo in pedagogia, Il Melangolo, Genova, 2016, pp. 197",
      "Franco Cambi, Giancarla Sola, Dante educatore europeo, Il Melangolo, Genova, 2020, pp. 218",
    ] },
    { titolo: "Volumi curati", voci: [
      "F. Rosenzweig, Ebraismo, Bildung e filosofia della vita, La Giuntina, Firenze, 2000, pp. 227",
      "Epistemologia pedagogia. Il dibattito contemporaneo in Italia, Bompiani, Milano, 2002, pp. 359",
      "Pedagogia e cultura. Venticinque anni di studi e ricerche attraverso il “Centro Studi Pedagogici Don Lorenzo Milani”, di Genova, Anicia, Roma, 2009, pp. 367",
      "Theodor W. Adorno, Teoria della Halbbildung, Il Melangolo, Genova, 2010, pp.107",
      "Hans-Georg Gadamer, Bildung e umanesimo, Il Melangolo, Genova, 2012, pp. 237",
      "Odo Marquard, Il manifesto pluralista?, Il Melangolo, Genova, 2016, pp. 175",
      "L’Eccezione Don Lorenzo Milani. A cento anni dalla nascita (1923-2023), Il Melangolo, Genova, 2023, pp. 180",
      "Ma chi ha detto che Babbo Natale non esiste?, Il Melangolo Genova, pp.180",
      "A. Gobetti, Pedagogia partigiana, (ed. G. Sola), Il Melangolo, Genova, 2025, pp. 170",
    ] },
  ] },
  { autore: "Anna Kaiser", sezioni: [
    { titolo: "Volumi", voci: [
      "Genius ludi: il gioco nella formazione umana, Armando, Roma, 1995, pp.160",
      "Antropologia pedagogica della ludicità, La Scuola, Brescia, pp.224",
      "Gnoseologia dell’educazione. 1. Lo statuto antropologico dell’essere spirituale, La Scuola, Brescia, 1998, pp. 208",
      "Pedagogia e ontologia. Saggio su Nicolai Hartmann, La Scuola, Brescia, 2003, pp. 224",
      "Filosofia dell’educazione (im Grundriß), Il Melangolo, Genova, 2013, pp. 177",
      "Il pensiero pedagogico di Epitteto, Aracne, Roma, 2023, pp. 126",
    ] },
    { titolo: "Volumi in collaborazione", voci: [
      "Mario Gennari, Anna Kaiser, Prolegomeni alla Pedagogia Generale, Bompiani Milano, 2000, pp. 124",
    ] },
    { titolo: "Volumi a cura", voci: [
      "Gioco e sport nelle scienze dell’educazione, Sagep, Genova, 1996, pp. 256",
      "La Bildung ebraico-tedesca del Novecento, Bompiani, Milano, 1996, 2006, pp. 491",
      "(Eds. con Francesca Marcone) Dizionario pedagogico della dichiarazione universale dei diritti umani, Aracne, Roma, 2020, pp. 168",
    ] },
  ] },
  { autore: "Paolo Levrero", sezioni: [
    { titolo: "Volumi", voci: [
      "L’ebreo don Milani, Il Melangolo, Genova, 2013, pp. 141",
      "Transculture mediterranee: pratiche pedagogiche tra immigrazione e integrazione, Aracne, Roma, 2016, pp. 340",
      "Hans-Georg Gadamer. Per una ermeneusi della formazione umana, Anicia, Roma, 2022, pp. 184",
      "La libertà si impara. Figure del Neoumanesimo pedagogico italiano: Balducci, Capitini, Milani, LEF, Firenze, 2024, pp. 140",
      "Figure del Neoumanesimo pedagogico europeo”, Studium, Roma, 2024, pp.160",
    ] },
    { titolo: "Volumi a cura", voci: [
      "Menschenbildung. L’idea di formazione dell’uomo in Johann Heinrich Pestalozzi, Il Melangolo, Genova, 2014, pp. 323",
      "Pedagogia della storia, Il Melangolo, Genova, 2017, pp. 230",
    ] },
  ] },
  { autore: "Edoardo Valter Tizzi", sezioni: [
    { titolo: "Volumi", voci: [
      "Schooling, Anicia, Roma, 2007, pp. 284",
      "Dalla scholé allo schooling, Morlacchi, Roma, 2008, pp. 178",
    ] },
    { titolo: "Volumi a cura", voci: [
      "Didattica. Itinerari bibliografici per la scuola materna elementare e media, Sagep, Genova, 1990, pp. 223",
    ] },
  ] },
  { autore: "Francesca Marcone", sezioni: [
    { titolo: "Volumi", voci: [
      "Saggio sull’Armonia. Tra musica, letteratura e formazione umana, Anicia, Roma, 2022. pp. 320",
      "Bach. Pedagogia della Bildung musicale, Il Melangolo, Genova, 2024, pp.164",
    ] },
    { titolo: "Volumi in collaborazione", voci: [
      "M. Gennari – F. Marcone, Allegorie dell’Infanzia, Il Melangolo, Genova, 2024, pp. 240",
    ] },
    { titolo: "Volumi a cura", voci: [
      "(Eds. con Anna Kaiser) Dizionario pedagogico della dichiarazione universale dei diritti umani, Aracne, Roma, 2020, pp. 168",
    ] },
  ] },
  { autore: "Ilaria Barbieri", sezioni: [
    { titolo: "Volumi", voci: [
      "Architettonica di una Pedagogia della Vita, Aracne, Roma, 2021, pp. 144",
      "Україна. Ucraina. La guerra: i bambini, le donne, gli anziani. Uno sguardo pedagogico sul 2022-2023, Il Melangolo, Genova, 2024, pp. 136",
      "Tertium Comparationis. Pedagogie Comparate, Crisi Sociale, Pedagogia Clinica, Anicia, Roma, 2025, pp. 384",
    ] },
  ] },
  { autore: "Paola Poldiallai", sezioni: [
    { titolo: "Volumi curati", voci: [
      "Pedagogie del museo, Sagep, Genova, 1991, pp. 174",
    ] },
  ] },
  { autore: "Claudio Borello", sezioni: [
    { titolo: "Volumi curati", voci: [
      "Narratologia e didattica, Sagep, Genova, 1993, pp. 152",
    ] },
  ] },
  { autore: "Miriam Pertica", sezioni: [
    { titolo: "Volumi", voci: [
      "Il complesso di Èra. Handicap Città Educazione, Utet, Torino, 1997, pp. 229",
    ] },
  ] },
  { autore: "Cesare Ghezzi", sezioni: [
    { titolo: "Volumi", voci: [
      "Il bambino e la sua arte. Novantanove tesi, a cura di M. Gennari, Il Melangolo, Genova, 2010, pp. 130",
    ] },
  ] },
  { autore: "Alba Chiara Amadu", sezioni: [
    { titolo: "Volumi curati", voci: [
      "Fiaba per il Natale, Il Melangolo, Genova, 2015, pp. 64",
    ] },
  ] },
  { autore: "Giuliano Falco", sezioni: [
    { titolo: "Volumi", voci: [
      "Introduzione alla semiotica dell'educazione, Aracne, Roma, 2021, pp. 200",
    ] },
  ] },
  { autore: "Roberto Cantatore", sezioni: [
    { titolo: "Volumi", voci: [
      "Idee e movimenti nella storia della sinistra italiana. Riflessioni pedagogiche sulle origini (1876-1920), Aracne, Roma, 2018, pp. 128",
    ] },
  ] },
  { autore: "Marika Martini Welbergen", sezioni: [
    { titolo: "Volumi", voci: [
      "Sul Semplicismo, Il Melangolo, Genova, in corso di pubblicazione",
    ] },
  ] },
];

